import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import OnboardingCoachNotificationsContext from '../../../../context/OnboardingCoachNotificationsContext';
import { getOnboardingChecklistByCoach } from '../../../../Model/CoachHistory';
import {
  StyledLinearProgress,
  StyledBox,
  StyledTypography,
  StyledProgressHeader,
  StyledPercentage,
} from './styles';
import texts from './texts.json';

const OnboardingProgressBar = ({
  onboardingChecklistCount,
  isNewCoachAccount,
  accountCreatedAt,
  isCoachLeadView,
  isEnrolledInISProgram,
}) => {
  const { TOTAL_ONBOARDING_TASKS_EXISTING_COACH } = useContext(OnboardingCoachNotificationsContext);

  // Use appropriate total tasks based on account type
  // For coaches enrolled in IS program, reduce total tasks by 1 (IS AC questionnaire is not required)
  // This is because coaches in the IS program don't need to complete the IS AC questionnaire
  // as they are already part of the Inside Sales program
  let totalTasks;
  if (isNewCoachAccount) {
    // The first chat message step only applies to recent accounts
    const newCoachTaskCount = getOnboardingChecklistByCoach(accountCreatedAt).length;
    totalTasks = isEnrolledInISProgram ? newCoachTaskCount - 1 : newCoachTaskCount;
  } else {
    totalTasks = TOTAL_ONBOARDING_TASKS_EXISTING_COACH;
  }

  const progress = totalTasks > 0
    ? Math.round((onboardingChecklistCount / totalTasks) * 100)
    : 0;

  return (
    <StyledBox>
      <StyledLinearProgress variant="determinate" value={progress} />
      {isCoachLeadView ? (
        <StyledProgressHeader>
          <StyledTypography variant="body2">
            {format(texts.progressTextCoachLeadView, { completed: onboardingChecklistCount, total: totalTasks })}
          </StyledTypography>
          <StyledPercentage variant="body2">
            {`${progress}%`}
          </StyledPercentage>
        </StyledProgressHeader>
      ) : (
        <StyledTypography variant="body2">
          {format(texts.progressText, { completed: onboardingChecklistCount, total: totalTasks })}
        </StyledTypography>
      )}
    </StyledBox>
  );
};

OnboardingProgressBar.propTypes = {
  onboardingChecklistCount: PropTypes.number,
  isCoachLeadView: PropTypes.bool,
  isNewCoachAccount: PropTypes.bool,
  accountCreatedAt: PropTypes.instanceOf(Date),
  isEnrolledInISProgram: PropTypes.bool,
};

OnboardingProgressBar.defaultProps = {
  onboardingChecklistCount: 0,
  isCoachLeadView: false,
  isNewCoachAccount: false,
  accountCreatedAt: undefined,
  isEnrolledInISProgram: false,
};

export default OnboardingProgressBar;
